<template>
	<div class="b-form__calendar">
		<div class="b-form__calendarItem b-form__calendarItem_date date-control">
			<input type="text" autocomplete="off" :placeholder="format" data-input :value="dateValue"/>
			<span class="select_toggle b-form__calendarToggle" data-toggle>
				<i class="icon icon--arrow-down"></i>
			</span>
		</div>
		<div class="b-form__calendarItem b-form__calendarItem_time time-control" v-if="timeSeparated">
			<input type="text" autocomplete="off" :placeholder="timeFormat" data-input :value="timeValue"/>
			<span class="select_toggle b-form__calendarToggle" data-toggle>
				<i class="icon icon--arrow-down"></i>
			</span>
		</div>
	</div>
</template>
<script>
	export default {
		name: "CitrusDatePick",
		props: {
			format: {
				type: String,
				default: "d.m.Y",
			},
			timeFormat: {
				type: String,
				default: "H:i",
			},
			timeSeparated: {
				type: Boolean,
				default: false,
			},
			params: {
				type: [Object, Array],
				default: function () {
					return {}
				},
			},
			timeParams: {
				type: [Object, Array],
				default: function () {
					return {}
				},
			},
			yearHidden: {
				type: Boolean,
				default: false,
			}
		},
		data() {
			return {
				inputFocus: false,
				error: false,
				dateValue: "",
				timeValue: "",
				inputValue: "",
				dateOptions: {},
				timeOptions: {},
				defaultOptions: {
					locale: "ru",
					dateFormat: "Y-m-d",
					defaultDate: "",
					wrap: true
				}
			}
		},
		watch: {
			disable: function () {
				this.$nextTick(this.redraw);
			},
			format: function () {
				this.$nextTick(this.redraw);
			},
			timeFormat: function () {
				this.$nextTick(this.redraw);
			},
			params: {
				handler: function() {
					this.$nextTick(this.redraw);
				},
				deep: true,
			},
			timeParams: {
				handler: function() {
					this.$nextTick(this.redraw);
				},
				deep: true,
			},
			value(newValue, oldValue) {
				if (this.inputValue == newValue) {
					return;
				}

				this.inputValue = newValue;
				this.initFullValue();
				this.$nextTick(this.redraw);
			},
		},
		created: function () {
			this.inputValue = Array.isArray(this.value) ? this.value[0] : this.value;
			this.initFullValue();
		},
		mounted() {
			this.$nextTick(this.redraw);
		},
		methods: {
			onChangeTime(selectedDates, value, instance) {
				/**
				 * На мобильных устройствах в поле время не применяются ограничения, проверим вручную
				 */
				if (instance && instance.isMobile && this.timeParams) {
					var newValue = null;
					if (this.timeParams.minTime && value < this.timeParams.minTime) {
						newValue = this.timeParams.minTime;
					}

					if (this.timeParams.maxTime && value > this.timeParams.maxTime) {
						newValue = this.timeParams.maxTime;
					}

					if (newValue !== null) {
						value = newValue;
						if (instance.mobileInput) {
							instance.mobileInput.value = newValue;
						}

						if (instance.input !== undefined) {
							instance.input.value = instance.getDateStr(instance.config.dateFormat);
						}

						if (instance.altInput !== undefined) {
							instance.altInput.value = instance.getDateStr(instance.config.altFormat);
						}
					}
				}

				this.timeValue = value;

				// TODO обновляется по событию закрытия календаря-времени
				// this.updateFullValue();
			},
			onChange(selectedDates, value, instance) {
				this.dateValue = value;
				this.updateFullValue();
			},
			initFullValue() {
				let arValues = this.inputValue !== null ? this.inputValue.split(" ") : [];

				this.dateValue = (arValues.length >= 1) ? arValues[0] : "";
				this.timeValue = (arValues.length >= 2) ? arValues[1] : "";
			},
			updateFullValue() {
				let newValue = this.dateValue + (this.timeValue ? " " + this.timeValue : "");
				if (this.inputValue == newValue) {
					return;
				}

				this.inputValue = newValue;
				this.$emit("input", this.inputValue);
			},
			formatDayOrMonth(data) {
				if (data < 10) {
					return "0" + data;
				}
				return data;
			},
			redraw: function () {
				const exludedDates = this.$store.getters['basket/excludedDates'];
				console.log('Исключённые даты', exludedDates);
				if (!!exludedDates) {
					this.defaultOptions.disable = exludedDates;
				}
				this.dateOptions = Object.assign({},
					this.defaultOptions,
					{
						dateFormat: this.format,
						onChange: this.onChange,
						onReady: (selectedDates, value, instance) => {
							if (this.yearHidden && instance.hasOwnProperty("calendarContainer")) {
								let container = instance.calendarContainer;
								container.classList.add("is-year-hidden");
							}
						}
					},
					this.params
				);

				if (this.dateOptions.defaultDate && this.dateValue == "") {
					this.dateValue = this.dateOptions.defaultDate;
				}
				if (!!exludedDates) {
					exludedDates.forEach((item) => {
						const start = new Date(item.from.replace( /(\d{2})-(\d{2})-(\d{4})/, "$2/$1/$3"));
						let end = new Date(item.to.replace( /(\d{2})-(\d{2})-(\d{4})/, "$2/$1/$3"));
						const cur = new Date(this.dateValue.replaceAll(".", "-").replace( /(\d{2})-(\d{2})-(\d{4})/, "$2/$1/$3"));
						if (cur >= start && cur <= end) {
							end.setDate(end.getDate() + 1);
							this.dateValue = this.formatDayOrMonth( end.getDate())+"."+this.formatDayOrMonth(end.getMonth() + 1)+"."+end.getFullYear();
						}
					});
				}

				this.dateOptions.defaultDate = this.dateValue;

				$(this.$el).find(".date-control").flatpickr(this.dateOptions);

				if (!this.timeSeparated) {
					this.updateFullValue();
					return;
				}

				this.timeOptions = Object.assign({},
					this.defaultOptions,
					{
						enableTime: true,
						time_24hr: true,
						noCalendar: true,
						dateFormat: this.timeFormat,
						onChange: this.onChangeTime,
						onClose: this.onCloseTime
					},
					this.timeParams
				);

				if (this.timeOptions.defaultDate && this.timeValue == "") {
					this.timeValue = this.timeOptions.defaultDate;
				}

				// TODO требует рефакторинга
				const minTime = new Date("2021-09-25T"+this.timeParams.minTime + ":00");
				const maxTime = new Date("2021-09-25T"+this.timeParams.maxTime + ":00");
				const curTime = new Date("2021-09-25T"+this.timeValue + ":00");
				if (!(curTime >= minTime && curTime <= maxTime)) {
					this.timeValue = this.timeParams.minTime;
				}
				this.timeOptions.defaultDate = this.timeValue;

				$(this.$el).find(".time-control").flatpickr(this.timeOptions);

				this.updateFullValue();
			},
			onCloseTime() {
				this.updateFullValue();
			}
		}
	}
</script>